<template>
  <div class="phone-number">
    <div class="phone-code">
      <img
        class="country"
        :src="model.areaCodeImg"
        alt=""
      >
      <div class="input-wrapper">
        <input
          @focus="onPhoneCodeInputFocus"
          @blur="onPhoneCodeInputBlur"
          @input="onPhoneCodeInput"
          v-model="model.phoneCode"
          class="phone-code-input"
          type="text"
        >
        <div
          v-if="showPhoneCodeHint"
          class="hint"
        >
          {{ lastPhoneCode }}
        </div>
      </div>
      <Icon
        class="icon"
        name="arrow-down-l-2"
      />
    </div>
    <input
      v-model="model.phone"
      class="phone-number-input"
      placeholder="Mobile No. / Phone*"
      type="text"
    >

    <!-- 下拉选择 -->
    <div
      v-if="showPhoneNumberScrolldown"
      class="scroll-down-list"
    >
      <div
        @mousedown="onSelectPhoneCode(item)"
        v-for="(item, index) in scrollList"
        :key="index"
        class="scroll-down-list-item"
      >
        <img
          class="image"
          :src="item?.countryUrl"
          alt=""
        >
        <div class="text">
          {{ `${ item.countryName } (${item.phoneCode})` }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { Icon } from '@/components/Icon'

const props = defineProps({
  model: {
    type: Object,
    default: () => ({})
  },
  countryList: {
    type: Array,
    default: () => []
  }
})

const showPhoneCodeHint = ref(false)

const lastPhoneCode = ref('')

const showPhoneNumberScrolldown = ref(false)

const scrollList = ref(props.countryList)

const onPhoneCodeInputFocus = () => {
  scrollList.value = props.countryList

  lastPhoneCode.value = props.model.phoneCode
  props.model.phoneCode = ''

  showPhoneCodeHint.value = true
  showPhoneNumberScrolldown.value = true
}

const onPhoneCodeInputBlur = () => {
  if (lastPhoneCode.value) {
    props.model.phoneCode = lastPhoneCode.value
  }
  lastPhoneCode.value = ''

  showPhoneCodeHint.value = false
  showPhoneNumberScrolldown.value = false
}

const onSelectPhoneCode = (item) => {
  lastPhoneCode.value = ''
  props.model.phoneCode = item.phoneCode
  props.model.areaCodeImg = item.countryUrl
  showPhoneCodeHint.value = false
}

const onPhoneCodeInput = (e) => {
  showPhoneCodeHint.value = false
  const val = String(e.target.value).toLowerCase()
  scrollList.value = props.countryList.filter(item => {
    const countryName = String(item.countryName).toLowerCase()
    const phoneCode = item.phoneCode
    return countryName.includes(val) || phoneCode.includes(val)
  })
}
</script>

<style lang='less' scoped>
.phone-number {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: 8px;
  width: 390px;
  .phone-code {
    position: relative;
    width: 149px;
    height: 40px;

    .input-wrapper {
      position: relative;
      .phone-code-input {
        border: none;
        outline: none;
        width: 100%;
        height: 40px;
        color: #232323;
        font-size: 12px;
        font-family: mon-500;
        border: 1px solid #ebf1f5;
        border-radius: 4px;
        padding: 0 36px;
        &:focus {
          border: 2px solid #232323;
        }
      }
      .hint {
        position: absolute;
        top: 50%;
        left: 36px;
        transform: translateY(-50%);
        color: #b2b7c2;
        font-size: 12px;
        font-family: mon-500;
      }
    }
    .country, .icon {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      z-index: 9;
    }

    .country {
      left: 8px;
      width: 20px;
      object-fit: contain;
    }
    .icon {
      right: 8px;
    }
  }
  .phone-number-input {
    flex: 1;
    outline: none;
    border: 1px solid #ebf1f5;
    border-radius: 4px;
    padding: 0 16px;
    height: 40px;
    color: #232323;
    font-size: 12px;
    font-family: mon-500;
    &:focus {
      border: 2px solid #232323;
    }
    &::placeholder {
      color: #b2b7c2;
      font-size: 12px;
      font-family: mon-500;
    }
  }
  .scroll-down-list {
    position: absolute;
    top: calc(100% + 8px);
    left: 0;
    width: 100%;
    height: 186px;
    overflow: scroll;
    padding: 8px 4px;
    border: 1px solid #ebf1f5;
    border-radius: 4px;
    background-color: white;
    .scroll-down-list-item {
      display: flex;
      align-items: center;
      gap: 6px;
      height: 34px;
      border-radius: 2px;
      padding: 0 12px;
      &:hover {
        background-color: #f8f8f8;
        cursor: pointer;
      }
      .image {
        width: 16px;
        object-fit: contain;
      }
      .text {
        color: #232323;
        font-size: 11px;
        font-family: mon-500;
      }
    }
  }
}
</style>
